export const AVAILABILITY = {
  pickup: "Pickup",
  delivery: "Delivery",
  pickupDelivery: "Pickup & Delivery",
};

export const CATEGORY_NAMES: { [category: string]: string } = {
  Flower: "Flower",
  Concentrate: "Concentrates",
  Edible: "Edibles",
  Cartridge: "Cartridges",
  PreRoll: "Pre-rolls",
  Topical: "Topicals",
  Accessory: "Accessories",
};

export const DISPENSARY_PLACEHOLDER_PHOTO =
  "https://leafly-public.imgix.net/dispensary/static/placeholder-dispensary-photo.jpg";

export const SHOP_TAB_NAMES: { [tab: string]: string } = {
  brand: "Brands",
  dispensary: "Dispensaries",
  strain: "Strains",
};

export const SEARCH_RESULT_CATEGORY_NAMES: { [category: string]: string } = {
  all: "All results",
  strain: "Strains",
  menuItem: "Products",
  dispensary: "Dispensaries",
  brand: "Brands",
  article: "News & culture",
};

export const PAGES = {
  main: "main",
  menu: "menu",
  deals: "deals",
  about: "about",
  reviews: "reviews",
  photos: "photos",
  appointment: "appointment",
};

export const DISPENSARY_TABS_US = {
  [PAGES.main]: {
    page: PAGES.main,
    href: "/dispensary-info/[slug]",
  },
  [PAGES.menu]: {
    page: PAGES.menu,
    href: "/dispensary-info/[slug]/menu",
  },
  [PAGES.deals]: {
    page: PAGES.deals,
    href: "/dispensary-info/[slug]/deals",
  },
  [PAGES.reviews]: {
    page: PAGES.reviews,
    href: "/dispensary-info/[slug]/reviews",
  },
};

export const CBD_STORE_TABS = {
  [PAGES.main]: {
    page: PAGES.main,
    href: "/cbd-store/[slug]",
  },
  [PAGES.menu]: {
    page: PAGES.menu,
    href: "/cbd-store/[slug]/menu",
  },
  [PAGES.deals]: {
    page: PAGES.deals,
    href: "/cbd-store/[slug]/deals",
  },
  [PAGES.reviews]: {
    page: PAGES.reviews,
    href: "/cbd-store/[slug]/reviews",
  },
};

export const DISPENSARY_TABS_CA = {
  [PAGES.main]: {
    page: PAGES.main,
    href: "/cannabis-store/[slug]",
  },
  [PAGES.menu]: {
    page: PAGES.menu,
    href: "/cannabis-store/[slug]/menu",
  },
  [PAGES.deals]: {
    page: PAGES.deals,
    href: "/cannabis-store/[slug]/deals",
  },
  [PAGES.reviews]: {
    page: PAGES.reviews,
    href: "/cannabis-store/[slug]/reviews",
  },
};

export const DOCTOR_TABS = {
  [PAGES.about]: {
    page: PAGES.about,
    href: "/doctors/[slug]",
  },
  [PAGES.reviews]: {
    page: PAGES.reviews,
    href: "/doctors/[slug]/reviews",
  },
  [PAGES.appointment]: {
    page: PAGES.appointment,
    href: "/doctors/[slug]/appointment",
  },
};
